import { render, staticRenderFns } from "./VaBack.vue?vue&type=template&id=c03583f8&scoped=true&"
import script from "./VaBack.vue?vue&type=script&lang=ts&"
export * from "./VaBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03583f8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c03583f8')) {
      api.createRecord('c03583f8', component.options)
    } else {
      api.reload('c03583f8', component.options)
    }
    module.hot.accept("./VaBack.vue?vue&type=template&id=c03583f8&scoped=true&", function () {
      api.rerender('c03583f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/VaBack.vue"
export default component.exports